// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const ACTION_STATUS_FAILED = 'ACTION_STATUS_FAILED';
export const ACTION_STATUS_STARTED = 'ACTION_STATUS_STARTED';
export const ACTION_STATUS_SUCCESS = 'ACTION_STATUS_SUCCESS';
export const ACTION_STATUS_ACCEPTED = 'ACTION_STATUS_ACCEPTED';
export const ACTION_STATUS_RESET = 'ACTION_STATUS_RESET';
export const RESET_ACTIONS_DATA = 'RESET_ACTIONS_DATA';

export const {
    actionStatusFailed,
    actionStatusStarted,
    actionStatusSuccess,
    actionStatusAccepted,
    actionStatusReset,
    resetActionsData,
} = createActions(
    ACTION_STATUS_FAILED,
    ACTION_STATUS_STARTED,
    ACTION_STATUS_SUCCESS,
    ACTION_STATUS_ACCEPTED,
    ACTION_STATUS_RESET,
    RESET_ACTIONS_DATA
);
